/*
 * @Author: Claude Code
 * @Date: 2026-03-03
 * @Description: 首页视频资源配置
 */

/**
 * 首页功能卡片视频 URL
 */
export const HOME_FEATURE_VIDEOS = {
  VIDEO_GENERATE:
    'https://common-qa-nx.s3.cn-northwest-1.amazonaws.com.cn/20017-1/asset/20260311/generatevideo_1814737965231136768.mp4',
  AVATAR_VIDEO:
    'https://common-qa-nx.s3.cn-northwest-1.amazonaws.com.cn/20017-1/asset/20260304/filev300vf4482b25fd6f54f958ea5dbe6b96326fg_1812155764123652096.mp4?x-id=PutObject',
  VIDEO_TRANSLATION:
    'https://common-qa-nx.s3.cn-northwest-1.amazonaws.com.cn/20017-1/asset/20260311/20260311172348_1814738840439775232.mp4',
} as const;
